<script lang='ts'>
import type { PropType } from 'vue'
import { Rank } from '@element-plus/icons-vue'
import Sortable from 'sortablejs'
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'MsDragTable',
  components: {
    Rank,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    showDrag: {
      type: Boolean,
      default: true,
    },
    showDragFn: {
      type: Function as PropType<(row, index) => boolean>,
    },
    rowKey: {
      type: String,
      default: 'id',
    },
    rowKeyFn: {
      type: Function as PropType<(item: any) => any>,
    },
  },
  emits: ['drag-change'],
  setup(props, { emit }) {
    const tableRef = ref()

    function showDragIcon(row, index): boolean {
      if (props.showDragFn) {
        return props.showDragFn(row, index)
      }
      return props.showDrag
    }

    function onRowDrag() {
      const tbody = tableRef.value.$el.querySelector('.el-table__body-wrapper tbody')
      Sortable.create(tbody, {
        handle: '.rank',
        animation: 150,
        onEnd: ({
          newIndex,
          oldIndex,
        }) => {
          if (typeof newIndex === 'number' && typeof oldIndex === 'number') {
            const currRow = props.data.splice(oldIndex, 1)[0]
            props.data.splice(newIndex, 0, currRow)
            emit('drag-change')
          }
        },
      })
    }

    return {
      tableRef,
      showDragIcon,
      onRowDrag,
    }
  },
})
</script>

<template>
  <el-table
    ref="tableRef"
    :data="data"
    v-bind="$attrs"
    :row-key="r => rowKeyFn ? rowKeyFn(r) : r[rowKey]"
    @cell-mouse-enter.once="onRowDrag"
  >
    <el-table-column align="center" width="50">
      <template #default="{ row, $index }">
        <el-icon v-if="showDragIcon(row, $index)" class="rank">
          <Rank />
        </el-icon>
      </template>
    </el-table-column>
    <slot />
    <template v-if="!!$slots.append" #append>
      <slot name="append" />
    </template>
  </el-table>
</template>

<style lang='scss' scoped>
.el-icon-rank {
  cursor: move;
}

::v-deep(.el-table__body) {
  tr:hover > td {
    background-color: #ffffff !important;
  }

  .sortable-chosen,
  .sortable-chosen:hover > td {
    background-color: #fef0f0 !important;
  }
}
</style>
